import React, { useEffect, useRef } from "react";

const VideoModal = ({ onClose, currentVideo }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const videoElement = videoRef.current;
    if (videoElement) {
      videoElement.requestFullscreen?.();
      videoElement.play();
    }
  }, []);

  return (
    <div className="h-full w-full absolute bg-black top-0 left-0 flex items-center justify-center text-white z-40">
      <div className="relative w-[90%] max-w-3xl">
        <video
          ref={videoRef}
          className="w-full h-auto rounded-lg"
          controls
          autoPlay
        >
          <source src={currentVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <button
          className="absolute top-2 right-2 bg-gray-800 px-3 py-2 rounded-full text-white"
          onClick={onClose}
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default VideoModal;
